import * as React from "react";
import { useEffect } from "react";
import { Button, Input, Modal } from "antd";
import { InputConnector, InputConnectorsApi } from "../../client";
import { JsonData, JsonEditor } from "json-edit-react";
import { get, set } from "lodash";

interface IProps {
    inputConnector: InputConnector;
    onClose: (isChanged: boolean) => void;
}

export const InputConnectorVariablesModal: React.FC<IProps> = (props) => {
    const [data, setData] = React.useState<JsonData>({});
    const [baseData, setBaseData] = React.useState<JsonData>({});
    const [searchValue, setSearchValue] = React.useState("");

    useEffect(() => {
        new InputConnectorsApi()
            .variablesInputConnectorVariables({
                id: props.inputConnector.id.toString(),
            })
            .then((res) => {
                setData(res.data.merged);
                setBaseData(res.data.base);
            });
    }, [props.inputConnector]);

    return (
        <Modal
            open={true}
            title="Input connector variables"
            onCancel={() => props.onClose(false)}
            width="1100px"
            footer={[
                <Button
                    danger={true}
                    onClick={() => {
                        Modal.confirm({
                            title: "This will reset the variables the original variables",
                            onOk: () => setData(baseData),
                            type: "warning",
                        });
                    }}
                >
                    Reset
                </Button>,
                <Button
                    type="primary"
                    onClick={async () => {
                        try {
                            const response =
                                await new InputConnectorsApi().partialUpdateInputConnector(
                                    {
                                        id: props.inputConnector.id.toString(),
                                        partialInputConnector: {
                                            variables: data as object,
                                        },
                                    }
                                );
                            if (response.status === 200) {
                                Modal.success({
                                    title: "Successfully saved",
                                });
                                props.onClose(true);
                                return;
                            }
                        } catch (e) {
                            console.error(e);
                        }
                        Modal.error({
                            title: "something went wrong",
                        });
                    }}
                >
                    Save
                </Button>,
            ]}
        >
            <div style={{ marginBottom: "1em" }}>
                <Input.Search
                    placeholder="search..."
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                />
            </div>
            <JsonEditor
                data={data}
                maxWidth="100%"
                restrictDrag={true}
                restrictAdd={(e) => {
                    if (typeof e.value === "object" && e.level >= 1) {
                        return false;
                    }
                    return true;
                }}
                onAdd={(e) => {
                    const parentPath = e.path
                        .slice(0, e.path.length - 1)
                        .join(".");

                    const parent = get(e.currentData as object, parentPath);
                    const firstKey =
                        Object.keys(parent).length > 0
                            ? Object.keys(parent)[0]
                            : null;
                    const newValue = firstKey ? parent[firstKey] : "";
                    const newData = set(e.newData as object, e.path, newValue);
                    setData(newData);
                    return ["value", newData];
                }}
                restrictDelete={(e) => e.level <= 1}
                restrictEdit={(e) => e.level < 1}
                restrictTypeSelection={true}
                showCollectionCount={true}
                insertAtTop={true}
                rootName=""
                searchFilter="all"
                searchText={searchValue}
                searchDebounceTime={500}
                onUpdate={(e) => setData(e.newData)}
            />
        </Modal>
    );
};
